import ShippingAddresses from './shippingAddresses';

export default ShippingAddresses;